import { Injectable } from '@angular/core';

@Injectable()
export class AuthService {
  
  constructor() {}

  public isAuthenticated(): boolean {
    if(sessionStorage.getItem('status')==null){
        return false;
    }else{
      if(sessionStorage.getItem('status')=='null'){
        return false;
      }else return true;
    }
  }
}